module.exports = __webpack_public_path__ + "static/img/none.034d5030.jpg";